import axios, { type AxiosResponse } from 'axios';

export * from './account';
export * from './addressLookup';
export * from './ai';
export * from './aiChat';
export * from './basisOfEstimate';
export * from './content';
export * from './credits';
export * from './goldDashboard';
export * from './helper';
export * from './policyPacks';
export * from './project';
export * from './projectStatistics';
export * from './projectSupport';
export * from './settings';
export * from './site';

export const apiInterceptor = (success: (resp: AxiosResponse) => void, error: (err: any) => void) => {
  axios.interceptors.response.use(
    (resp) => {
      success(resp);
      return resp;
    },
    (err) => {
      error(err);
      return Promise.reject(err);
    },
  );
};
